/**
 * Replace all pipe symbols with a single space. Leading and trailing spaces are removed.
 */
export const hidePipeSymbols = (text: string): string => text.replace(/\s*\|+\s*/g, ' ').trim();
